<script setup lang="ts">
import { useUsersStore } from '~/stores/users'
import type { LengthUnit } from '~/types/elementsUi'

interface PsychologyIconProps {
  height: LengthUnit
  width: LengthUnit
}

const props = defineProps<PsychologyIconProps>()

const localeStore = useLocaleStore()
const altTexts = {
  nl: 'Icoon van een tandwiel in het hoofd van een persoon',
  en: 'Icon of a gearwheel inside the head of a person'
}
const altTag = computed(() => altTexts[localeStore.locale] ?? altTexts.nl)
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-240 -1200 1440 1440"
    :height="height"
    :width="width"
    fill="currentColor"
  >
    <title>{{ altTag }}</title>
    <path
      d="M240-80v-172q-57-52-88.5-121.5T120-520q0-150 105-255t255-105q125 0 221.5 73.5T827-615l52 205q5 19-7 34.5T840-360h-80v120q0 33-23.5 56.5T680-160h-80v80h-80v-160h160v-200h108l-38-155q-23-91-98-148t-172-57q-116 0-198 81t-82 197q0 60 24.5 114t69.5 96l26 24v208h-80Zm254-360Zm-54 80h80l6-50q8-3 14.5-7t11.5-9l46 20 40-68-40-30q2-8 2-16t-2-16l40-30-40-68-46 20q-5-5-11.5-9t-14.5-7l-6-50h-80l-6 50q-8 3-14.5 7t-11.5 9l-46-20-40 68 40 30q-2 8-2 16t2 16l-40 30 40 68 46-20q5 5 11.5 9t14.5 7l6 50Zm-2.5-117.5Q420-495 420-520t17.5-42.5Q455-580 480-580t42.5 17.5Q540-545 540-520t-17.5 42.5Q505-460 480-460t-42.5-17.5Z"
    />
  </svg>
</template>

<style scoped></style>
